module.exports = __webpack_public_path__ + "media/Message In A Bottle.fd8cc19d.mp3";